export default "__VITE_ASSET__o0vDcArB__"